const animation = require("./Phone_Selecting Capture.json");

module.exports = {
    loop: true,
    autoplay: true,
    prerender: true,
    renderer: "svg",
    animationData: animation,
    rendererSettings: {
        preserveAspectRatio: 'xMidyMid'
    },
}